import { render, staticRenderFns } from "./NetworkStatusBanner.vue?vue&type=template&id=13be3852&scoped=true&"
import script from "./NetworkStatusBanner.vue?vue&type=script&lang=js&"
export * from "./NetworkStatusBanner.vue?vue&type=script&lang=js&"
import style0 from "./NetworkStatusBanner.vue?vue&type=style&index=0&id=13be3852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be3852",
  null
  
)

export default component.exports